'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contentSuggestionsWidget;

var _actionTypes = require('../../actions/action-types');

function contentSuggestionsWidget() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var isFetching = void 0;
  var showTeammates = void 0;

  switch (action.type) {
    case _actionTypes.SHOULD_UPDATE_FOLLOWING_STATUS:
      return Object.assign({}, state, {
        shouldUpdateFollowingTeam: action.payload.newValue
      });
    case _actionTypes.UPDATE_FOLLOWING_STATUS:
      var newValue = action.payload.newValue;

      return Object.assign({}, state, {
        isFollowingTeam: newValue,
        shouldUpdateFollowingTeam: false
      });
    case _actionTypes.UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS:
      return Object.assign({}, state, {
        isRefreshingWidgetSuggestions: action.payload.isFetching
      });
    case _actionTypes.UPDATE_IS_FETCHING_ATHLETES:
      isFetching = action.payload.isFetching;
      return Object.assign({}, state, {
        isFetchingAthletes: isFetching
      });
    case _actionTypes.UPDATE_IS_FETCHING_SUGGESTIONS:
      isFetching = action.payload.isFetching;
      return Object.assign({}, state, {
        isFetchingSuggestions: isFetching
      });
    case _actionTypes.UPDATE_SHOW_TEAMMATES_STATUS:
      showTeammates = action.payload.showTeammates;
      return Object.assign({}, state, {
        showTeammates: showTeammates
      });
    case _actionTypes.UPDATE_SHOW_ONBOARDING_BEACON:
      var showOnboardingBeacon = action.payload.showOnboardingBeacon.showOnboardingBeacon;

      return Object.assign({}, state, {
        showOnboardingBeacon: showOnboardingBeacon
      });
    case _actionTypes.UPDATE_SHOULD_REFRESH_SUGGESTIONS:
      var refreshSuggestions = action.payload.refreshSuggestions;

      return Object.assign({}, state, {
        refreshSuggestedAthletes: refreshSuggestions
      });
    case _actionTypes.UPDATE_DISPLAY_SUGGESTIONS_MODAL:
      var shouldShowModal = action.payload.shouldShowModal;

      return Object.assign({}, state, {
        shouldShowSuggestionsModal: shouldShowModal
      });
    case _actionTypes.UPDATE_HAS_MORE_SUGGESTIONS:
      return Object.assign({}, state, {
        hasMoreSuggestions: action.payload.newValue
      });
    default:
      return state;
  }
}